import { getIcon } from '../utils';
import * as React from 'react';
import { checkInModalState } from '@sandtech-hub-monorepo/ui-kit-site';
import { useGetMaybeViewer } from '@sandtech-hub-monorepo/ui-auth-kit';
import { HeaderLink } from './HeaderLink';
import { useMemo } from 'react';

export const AppItem = ({
  name,
  displayName,
  iconName,
  route,
  sdk,
  openCheckInModal,
}: {
  name: string;
  displayName: string;
  iconName: string;
  route: string;
  sdk: boolean;
  openCheckInModal: boolean;
}) => {
  const { viewer } = useGetMaybeViewer();
  const nameToDisplay = useMemo(
    () =>
      name !== 'Check In'
        ? displayName
        : !viewer?.currentCheckIn
        ? 'Check In'
        : 'Check Out',
    [viewer, name]
  );
  if (
    name === 'Check In' &&
    !viewer?.enrollmentFeatureAccess.hasCheckInAccess
  ) {
    return null;
  }

  if (
    name === 'AnswerBase' &&
    !viewer?.enrollmentFeatureAccess.hasAnswerbaseAccess
  ) {
    return null;
  }

  return (
    <>
      {!openCheckInModal ? (
        <HeaderLink href={route} sdk={sdk}>
          <li
            className="flex flex-col items-center gap-2 text-foreground cursor-pointer"
            key={name}
          >
            <div className="flex items-center justify-center w-12 h-12 border rounded-full">
              {getIcon(iconName)}
            </div>
            <p className="text-sm">{nameToDisplay}</p>
          </li>
        </HeaderLink>
      ) : (
        <li
          className="flex flex-col items-center gap-2 text-foreground cursor-pointer"
          key={name}
          onClick={() => {
            checkInModalState({ open: true });
          }}
        >
          <div className="flex items-center justify-center w-12 h-12 border rounded-full">
            {getIcon(iconName)}
          </div>
          <p className="text-sm">{nameToDisplay}</p>
        </li>
      )}
    </>
  );
};
